

import { makeStyles } from "@material-ui/core";

const useStyles = makeStyles((theme:any) => ({
  footer: {
    backgroundColor: "#1A364B",
    padding: "20px 30px",
  },
  footerContainer: {
    display: "flex",
    alignItems: "center",
    justifyContent: "space-between",
    color: "#fff",
    [theme.breakpoints.down('767')]: {
      flexWrap:'wrap',
      justifyContent:'center',
      textAlign:'center',
    }
  },
  socialMediaLinks: {
    display: "flex",
    alignItems: "center",
    justifyContent: "space-between",
  },
  leftSide: {
    "& li": {
      fontSize: "12px",
      lineHeight: "16px",
    },
  },
  rightSide: {
    display: "flex",
    justifyContent: "space-between",
    [theme.breakpoints.down('767')]: {
      flexWrap:'wrap',
      justifyContent:'center',
      textAlign:'center',
    },
    "& li": {
      fontSize: "12px",
      lineHeight: "16px",
      marginLeft: "10px",
      marginRight: "10px",
    },
  },
  copyRight: {
    margin: "0 20px",
    [theme.breakpoints.down('767')]: {
      margin: "10px 20px",
    },
  },
  termsConditionslink: {
    fontSize: "12px",
    color: "#fff",
    [theme.breakpoints.down('767')]: {
      marginTop:'10px'
    },
  },
  footerMailTo: {
    display:'inline-block',
    color:'#FFFFFF',
    marginTop:'1px',
    marginBottom:'1px',
    '&:hover':{ 
      color:'#5BC0F7'
    }
  }
}));

export default useStyles;